/*document.addEventListener('DOMContentLoaded', function () {
  const wishlistButtons = document.querySelectorAll('.wishlist-button');
  const removeWishlistButtons = document.querySelectorAll('.remove-wishlist-button');

  wishlistButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      Console.log("Helo");
      event.preventDefault(); // Prevent default behavior
      const productId = this.dataset.productId;
      let wishlist = getWishlist();
      if (wishlist.includes(productId)) {
        wishlist = wishlist.filter(id => id !== productId);
        this.classList.remove('added-to-wishlist');
      } else {
        wishlist.push(productId);
        this.classList.add('added-to-wishlist');
      }
      setWishlist(wishlist);
    });
  });

  removeWishlistButtons.forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default behavior
      const productId = this.dataset.productId;
      let wishlist = getWishlist();
      wishlist = wishlist.filter(id => id !== productId);
      setWishlist(wishlist);
      location.reload();
    });
  });

  function getWishlist() {
    const wishlist = localStorage.getItem('wishlist');
    return wishlist ? wishlist.split(',') : [];
  }

  function setWishlist(wishlist) {
    localStorage.setItem('wishlist', wishlist.join(','));
    document.cookie = 'wishlist_items=' + wishlist.join(',') + '; path=/';
  }
});
*/



// assets/wishlist.js





// assets/wishlist.js
 /*$(document).ready(function () {
  let wishlist = [];
  const storedWishlist = localStorage.getItem('wishlist');
  
  if (storedWishlist) {
    try {
      wishlist = JSON.parse(storedWishlist);
    } catch (error) {
      console.error('Error parsing wishlist from localStorage', error);
      wishlist = [];
    }
  }

  function renderWishlist() {
    const $wishlistContainer = $('#wishlist-items');
    $wishlistContainer.empty();
    if (wishlist.length) {
      wishlist.forEach(item => {
        $wishlistContainer.append(`
        
		  
		  
<div class="wishlist-product__list">
<div  class="c-product">
<a href="${item.url}">
<div class="grid-product__image-mask">
<div class="grid__image-ratio--square">
                        <img src="${item.image }" alt="${item.title}" data-widths="[360, 540, 720, 900, 1080]" data-sizes="auto">
</div>
</div>
                    </a>
					
  <span class="c-product__title card__heading">
                        <a class="full-unstyled-link" href="${item.url}">${item.title}</a>
                           <p>${item.price}</p>
                    </span>					
</div>
</div>	
          
        `);
      });
    } else {
      $wishlistContainer.append('<p>Your wishlist is empty.</p>');
    }
  }

  function addToWishlist(product) {
    const index = wishlist.findIndex(item => item.id === product.id);
    if (index === -1) {
      wishlist.push(product);
    } else {
      wishlist.splice(index, 1); // Remove if already in wishlist
    }
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    renderWishlist();
  }

  // Use a more specific parent element
  $('#wishlist-items').on('click', '.remove-from-wishlist', function () {
    const id = $(this).data('id');
    const index = wishlist.findIndex(item => item.id === id);
    if (index !== -1) {
      wishlist.splice(index, 1);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      renderWishlist();
    }
  });

  // Assuming the 'Add to Wishlist' button is inside a container with a specific class
  $('.product-container').on('click', '.add-to-wishlist', function () {
    const product = {
      id: $(this).data('id'),
      url: $(this).data('url'),
      image: $(this).data('image'),
      title: $(this).data('title'),
      price: $(this).data('price')
    };
    addToWishlist(product);
  });

  renderWishlist();
});


*/


$(document).ready(function () {
  let wishlist = [];
  const storedWishlist = localStorage.getItem('wishlist');

  if (storedWishlist) {
    try {
      wishlist = JSON.parse(storedWishlist);
    } catch (error) {
      console.error('Error parsing wishlist from localStorage', error);
      wishlist = [];
    }
  }

  function renderWishlist() {
    const $wishlistContainer = $('#wishlist-items');
    $wishlistContainer.empty();
    if (wishlist.length) {
      wishlist.forEach(item => {
        $wishlistContainer.append(`
       <div class="wishlist-product__list">
<div  class="c-product">
<a href="${item.url}">
<div class="grid-product__image-mask">
<div class="grid__image-ratio--square">
                        <img src="${item.image }" alt="${item.title}"

data-widths="[360, 540, 720, 900, 1080]"
               
                data-sizes="auto"
>
</div>
</div>
                    </a>
					<div class="wishgrid">
  <span class="c-product__title card__heading">
                        <a class="full-unstyled-link" href="${item.url}">${item.title}</a>
                           <p> ${item.currency} ${item.price}</p>
                    </span>		
                    <div class="wishlistaddbtn">
     
      <button 
                        type="button"
                        name="add"
                        id="addToCartwish"
                        class="wish-btn  add-to-cart"
                       data-variant-id="${item.variantId}" > <!-- Ensure productVariantId is passed as a number -->
                         
                        <span  class="addwishtext" id="AddToCartText-${item.title}" data-default-text="Add to Cart">
                           Add to Cart
                        </span>
                    </button>
     <button data-id="${item.id}" class="rmvbtn remove-from-wishlist"')">
     <span  class="MuiIconButton-label">
<svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24"  aria-hidden="true">
<path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
</svg>

</span>
     </button>
   </div>
   </div>
</div>
</div>	
        `);
      });
    } else {
      $wishlistContainer.append('<div class="emptywishlist">There are no items in this wishlist</div>');
    }

    // Update all 'Add to Wishlist' buttons to reflect the current wishlist state
    updateWishlistButtons();
  }

  function addToWishlist(product) {
    const index = wishlist.findIndex(item => item.id === product.id);
    if (index === -1) {
      wishlist.push(product);
    } else {
      wishlist.splice(index, 1); // Remove if already in wishlist
    }
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    renderWishlist();
  }

  function updateWishlistButtons() {
    $('.product-container .add-to-wishlist').each(function() {
      const id = $(this).data('id');
      const isInWishlist = wishlist.some(item => item.id === id);
      if (isInWishlist) {
        $(this).html(`
          <svg class="heart-filled" width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#FF0000"/>
          </svg> 
        `);
      } else {
         $(this).html(`
         <svg width="40px" height="40px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0" fill="none" width="24" height="24"/>  <g>
 <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>    </g>
                    </svg> 
        `);
        $(this).css('background-color', 'initial');
      }
    });
  }

  $('#wishlist-items').on('click', '.remove-from-wishlist', function () {
    const id = $(this).data('id');
    const index = wishlist.findIndex(item => item.id === id);
    if (index !== -1) {
      wishlist.splice(index, 1);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      renderWishlist();
    }
  });

  $('.product-container').on('click', '.add-to-wishlist', function () {
    const product = {
      id: $(this).data('id'),
      url: $(this).data('url'),
      image: $(this).data('image'),
      title: $(this).data('title'),
      price: $(this).data('price'),
      variantId: $(this).data('variant-id'),
       currency: $(this).data('currency'), // Add currency data
      //productVariant: "{{ product.selected_or_first_available_variant.id }}",
    };
    addToWishlist(product);
  });
 $('#wishlist-items').on('click', '.add-to-cart', function () {
    const variantId = $(this).data('variantId');
    addToCart(variantId);
  });

  function addToCart(variantId) {
    console.log(variantId);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: 1,
        id: variantId
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      //alert('Product added to cart');
       window.location.href = '/cart'; // Redirect to the cart page
      //document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
      //document.querySelector('.drawer').classList.add('drawer--is-open');
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      alert('There was an error adding the product to the cart.');
    });
  }
  renderWishlist();
});
